/**
 * Validates a given payload from the form
 * @param {object} payload - Payload to validate
 * @return {boolean}
 */
function validate(payload, schema, options) {
  try {
    schema.validateSync(payload, options);
  } catch (e) {
    return false;
  }
  return true;
}

export default validate;
